import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function VendorInquiries() {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to the new unified Messages Center
        navigate('/weddings/messages?filter=inquiries');
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <p>Redirecting to Messages...</p>
        </div>
    );
}


